'use client';

import type { ComponentProps } from 'react';

import { useNativeTokens } from '../_lib/use-native-tokens';

export function NativeFilterChip({
  active,
  count,
  children,
  style,
  ...props
}: ComponentProps<'button'> & { active: boolean; count?: number }) {
  const t = useNativeTokens();

  return (
    <button
      {...props}
      type="button"
      aria-pressed={active}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        minHeight: 44,
        minWidth: 44,
        padding: '8px 14px',
        borderRadius: 999,
        border: `1px solid ${active ? t.foreground : t.line}`,
        backgroundColor: active ? t.foreground : 'transparent',
        color: active ? t.background : t.muted,
        fontFamily: t.fontSans,
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '0.01em',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        scrollSnapAlign: 'start',
        ...style,
      }}
    >
      <span>{children}</span>
      {count !== undefined && (
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 18,
            height: 18,
            paddingInline: 5,
            borderRadius: 999,
            backgroundColor: active
              ? `color-mix(in srgb, ${t.background} 20%, transparent)`
              : `color-mix(in srgb, ${t.foreground} 6%, transparent)`,
            fontFamily: t.fontMono,
            fontSize: 10,
          }}
        >
          {count}
        </span>
      )}
    </button>
  );
}
